import {
  Message as UiMessage,
  MessageProps as UiMessageProps,
  MessageTheme as MessageStatus
} from '@platform/ui-library';
import { FC } from 'react';

export { MessageStatus };

export type MessageProps = Omit<UiMessageProps, 'theme'> & {
  status: MessageStatus;
};

export const Message: FC<MessageProps> = ({
  status,
  variant = 'compact',
  ...props
}) => {
  return <UiMessage theme={status} variant={variant} {...props} />;
};
